import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { CheckCircle } from "@mui/icons-material";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "./Footer";
import { useCurrency } from "../../context/currencyContext";
import { makeGetRequest } from "../../services/httpHelper";
import ErrorHandler from "../../services/ErrorHandler";


export default function PricingCardsPage() {
  const { edition } = useParams();
  const navigate = useNavigate();
  const { currency, setCurrency, convert } = useCurrency('KES');
   const [isLoading,setIsLoading] = useState(false);
   const [serverError,setServerError] = useState(null);
  const [plans, setPlans] = useState([]);

     const getPlans = async()=>{
        setIsLoading(true);
        const res = await makeGetRequest(`product/${edition}/plans`);
        if (res && res.errorType) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res)
            setServerError(errorMessage)
    
        } else {
          const results = await res.data;
          
            setPlans(results)        
            setIsLoading(false);
            setServerError(null)
            
    
        }
       
    }

  useEffect(() => {
   getPlans();
  }, [edition]);

  const buy = (plan) => {
    navigate(`/checkout?edition=${edition}&plan=${plan.name}`);
  };

 

  return (
    <>
      <TopNavbar returnTo />
      <PageWrapper>
        <Title>{edition.charAt(0).toUpperCase() + edition.slice(1)} Edition</Title>

       {/* <CurrencyToggle>
          <label>Currency:&nbsp;</label>
          <select value={currency} onChange={e => setCurrency(e.target.value)}>
            <option value="KES">KES</option>
            <option value="USD">USD</option>
          </select>
        </CurrencyToggle>*/}

        <CardGrid>
          {plans.map((p) => (
            <Card key={p.name}>
              <CardTitle>{p.name}</CardTitle>
              <CardPrice>
                {currency}{" "}
                {p.price_kes === 0
                  ? 0
                  : convert(p.price_kes / 100).toLocaleString()}
                {p.price_period === "yearly" && "/year"}
              </CardPrice>

              
              <BuyButton onClick={() => buy(p)}>
                {p.price_kes === 0 ? "Get Trial" : "Buy Now"}
              </BuyButton>

              <FeatureList>
                {p.features.map((f) => (
                  <FeatureItem key={f}>
                    <CheckCircle fontSize="small" color="success" />
                    {f}
                  </FeatureItem>
                ))}
              </FeatureList>
            </Card>
          ))}
        </CardGrid>
      </PageWrapper>
      <Footer />
    </>
  );
}

const PageWrapper = styled.div`
  padding: 40px 20px;
`;

const CurrencyToggle = styled.div`
  text-align: center;
  margin-bottom: 10px;
`;


const Title = styled.h2`
  text-align: center;
  font-size: 28px;
  margin-bottom: 30px;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
`;

const Card = styled.div`
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const CardTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 10px;
`;

const CardPrice = styled.p`
  font-size: 18px;
  color: purple;
  font-weight: bold;
`;

const BuyButton = styled.button`
  margin: 15px 0;
  padding: 10px 20px;
  background-color: purple;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    background-color: #5e2a84;
  }
`;

const FeatureList = styled.ul`
  margin-top: 15px;
  padding: 0;
  list-style: none;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;
